import Stack from "@mui/joy/Stack";
import React from "react";
import { Sidebar } from "../../shared/components/layout/Sidebar";

interface PageLayoutProps {
  readonly children: React.ReactNode;
  readonly noLayout: boolean;
}

export default function PageLayout({ children, noLayout }: PageLayoutProps) {
  if (noLayout) return <div style={{ overflow: "hidden", minHeight: "100vh" }}>{children}</div>;
  return (
    <div>
      <Sidebar />
      <Stack
        sx={{ ml: "241px", minHeight: "100vh" }}
        direction="column"
        justifyContent="space-between"
      >
        <div>{children}</div>
      </Stack>
    </div>
  );
}
